"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSectionList = createSectionList;
const createCardiology_1 = require("./createCardiology");
const createConsultations_1 = require("./createConsultations");
const createCovid_1 = require("./createCovid");
const createImagingProcedures_1 = require("./createImagingProcedures");
const createLabProcedures_1 = require("./createLabProcedures");
const createMedicalHistory_1 = require("./createMedicalHistory");
const createPreImmunisation_1 = require("./createPreImmunisation");
const createTomourResearch_1 = require("./createTomourResearch");
const createViralSerology_1 = require("./createViralSerology");
const createWaitingListData_1 = require("./createWaitingListData");
function createSectionList(intl, options) {
    return [
        (0, createPreImmunisation_1.createPreImmunisation)(intl, options),
        (0, createViralSerology_1.createViralSerology)(intl, options),
        (0, createWaitingListData_1.createWaitingListData)(intl, options),
        (0, createMedicalHistory_1.createMedicalHistory)(intl, options),
        (0, createCardiology_1.createCardiology)(intl, options),
        (0, createCovid_1.createCovid)(intl, options),
        (0, createLabProcedures_1.createLabProcedures)(intl, options),
        (0, createImagingProcedures_1.createImagingProcedures)(intl, options),
        (0, createTomourResearch_1.createTomourResearch)(intl, options),
        (0, createConsultations_1.createConsultations)(intl, options)
    ];
}
